import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
import { LogoMark } from './LogoMark';
import { getShopUrl } from '../data/shopUrls';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 text-white border-t border-white/5" data-id="element-89">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-12" data-id="element-90">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-91">
          {/* Column 1: Company Info */}
          <div data-id="element-92">
            <Link to="/" className="inline-block mb-6" data-id="element-93">
              <LogoMark size="md" variant="dark" data-id="element-94" />
            </Link>
            <div className="text-steel-500 text-sm space-y-1" data-id="element-95">
              <p data-id="element-96">Unit 12, Industrial Park</p>
              <p data-id="element-97">Hertfordshire</p>
              <p data-id="element-98">United Kingdom</p>
            </div>
            <div className="mt-6" data-id="element-99">
              <a href={getShopUrl()} target="_blank" rel="noopener noreferrer" className="text-white hover:text-cg-orange-600 text-sm transition-colors font-bold flex items-center gap-2" data-id="element-100">
                Browse Inventory <ExternalLink className="w-3 h-3" data-id="element-101" />
              </a>
            </div>
          </div>

          {/* Column 2: About Us */}
          <div data-id="element-102">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-103">
              About Us
            </h3>
            <ul className="space-y-3" data-id="element-104">
              <li data-id="element-105">
                <Link to="/about/who-we-are" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-106">
                  Who We Are
                </Link>
              </li>
              <li data-id="element-107">
                <Link to="/about/what-we-do" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-108">
                  What We Do
                </Link>
              </li>
              <li data-id="element-109">
                <Link to="/about/certifications" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-110">
                  Certifications
                </Link>
              </li>
              <li data-id="element-111">
                <Link to="/about/news" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-112">
                  News & Insights
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Manufacturing */}
          <div data-id="element-113">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-114">
              Manufacturing
            </h3>
            <ul className="space-y-3" data-id="element-115">
              <li data-id="element-116">
                <Link to="/manufacturing/markets" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-117">
                  Our Markets
                </Link>
              </li>
              <li data-id="element-118">
                <Link to="/manufacturing/processes" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-119">
                  Our Processes
                </Link>
              </li>
              <li data-id="element-120">
                <Link to="/manufacturing/defence-procurement" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-121">
                  Defence Procurement
                </Link>
              </li>
              <li data-id="element-122">
                <Link to="/manufacturing/frameworks" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-123">
                  Our Frameworks
                </Link>
              </li>
              <li data-id="element-124">
                <Link to="/manufacturing/catalogues" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-125">
                  Our Catalogues
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal & Contact */}
          <div data-id="element-126">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-127">
              Support & Legal
            </h3>
            <ul className="space-y-3 mb-8" data-id="element-128">
              <li data-id="element-129">
                <Link to="/faqs" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-130">
                  FAQs
                </Link>
              </li>
              <li data-id="element-131">
                <Link to="/contact" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-132">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-133">
                <Link to="/supplier-network" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-134">
                  Supplier Network
                </Link>
              </li>
              <li data-id="element-135">
                <Link to="/privacy-policy" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-136">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-137">
                <Link to="/terms-of-service" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-138">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-139">
                <Link to="/cookie-policy" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-140">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Office Locations — full-width row below main columns */}
        <div className="mt-12 pt-10 border-t border-white/10" data-id="element-141">
          <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-142">
            Office Locations
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8 max-w-2xl" data-id="element-143">
            {/* UK Office */}
            <div className="bg-navy-800 border border-white/10 p-5 rounded-sm" data-id="element-144">
              <div className="flex items-center gap-2 mb-3" data-id="element-145">
                <MapPin className="w-3.5 h-3.5 text-cg-orange-600 flex-shrink-0" data-id="element-146" />
                <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600" data-id="element-147">
                  United Kingdom
                </span>
              </div>
              <p className="text-white text-sm font-semibold mb-1" data-id="element-148">UK Office</p>
              <p className="text-steel-400 text-sm leading-relaxed" data-id="element-149">
                Unit 12, Industrial Park
                <br data-id="element-150" />
                Hertfordshire
                <br data-id="element-151" />
                United Kingdom
              </p>
              <div className="mt-3 flex items-center gap-2 text-steel-400 text-sm" data-id="element-152">
                <Phone className="w-3.5 h-3.5 text-steel-500 flex-shrink-0" data-id="element-153" />
                <span data-id="element-154">+44 (0) 1234 567890</span>
              </div>
            </div>

            {/* UAE Office */}
            <div className="bg-navy-800 border border-white/10 p-5 rounded-sm" data-id="element-155">
              <div className="flex items-center gap-2 mb-3" data-id="element-156">
                <MapPin className="w-3.5 h-3.5 text-cg-orange-600 flex-shrink-0" data-id="element-157" />
                <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600" data-id="element-158">
                  United Arab Emirates
                </span>
              </div>
              <p className="text-white text-sm font-semibold mb-1" data-id="element-159">
                UAE Office
              </p>
              <p className="text-steel-400 text-sm leading-relaxed" data-id="element-160">
                {/* Placeholder — update when address is confirmed */}
                [City], United Arab Emirates
              </p>
              <div className="mt-3" data-id="element-161">
                <span className="text-steel-600 text-xs italic" data-id="element-162">
                  Address to be confirmed
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/5 bg-navy-900" data-id="element-163">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-164">
          <p className="text-steel-500 text-xs" data-id="element-165">
            © Chiltern Global. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}